import { useState, useEffect } from 'react';
import { Button } from 'react-bootstrap';
import './ScrollToTop.scss';
export const ScrollToTop = () => {
  const [showButton, setShowButton] = useState(false);
  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.pageYOffset > 100) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, []);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth', // for smoothly scrolling
    });
  };
  return (
    <>
      {showButton && (
        <Button variant="primary" onClick={scrollToTop} className="back-to-top">
          <div className="material-icons">expand_less</div>
        </Button>
      )}
    </>
  );
};
